import AdoptionSurvey from "components/AdoptionSurvey";
import survey from "config/survey";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const IntakePage = () => {

    const navigate = useNavigate();
    const surveyComplete = useCallback(sender => {
        navigate('/transmitting', {state: {
            results: sender.data
        }})
    }, [navigate]);
    
    return <AdoptionSurvey survey={survey} onComplete={surveyComplete} />
}

export default IntakePage;